import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import Moment from "moment";
import "moment/locale/id";

function Step3() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  const listJson = pengajuan.getListKategoriJson;

  const lamaKerjaUsaha =
    valDetail.stepTiga.lamaKerjaUsaha === "-"
      ? "-"
      : Moment(valDetail.stepTiga.lamaKerjaUsaha).format("DD MMMM YYYY");

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka || 0);
  };

  const getLabel = (category, value) => {
    if (listJson && listJson[category]) {
      const found = listJson[category].find(
        (item) =>
          String(item.value).toLowerCase() === String(value).toLowerCase(),
      );
      return found ? found.label : value || "-";
    }
    return value || "-";
  };

  const InfoItem = ({
    label,
    value,
    col = 6,
    isPrimary = false,
    color = "black",
  }) => (
    <Col md={col} className="mb-3">
      <label
        className="text-muted fw-bold mb-1 d-block"
        style={{
          fontSize: "10px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </label>
      <div
        className={`p-2 rounded ${isPrimary ? "bg-light border" : ""}`}
        style={{
          fontSize: "14px",
          fontWeight: isPrimary ? "800" : "600",
          color: color,
          minHeight: "38px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {value || "-"}
      </div>
    </Col>
  );

  // Tentukan apakah ini tipe usaha atau pegawai untuk grouping
  const isUsaha =
    valDetail.tipeNasabah === "002" ||
    valDetail.stepTiga.statusPekerjaan === "wirausaha";

  return (
    <Row className="mt-3">
      <Col md="12">
        <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
          <Card.Body className="p-4">
            <div
              style={{
                maxHeight: "550px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
              className="custom-scrollbar pr-2"
            >
              <Row>
                {/* --- SEKSI 1: STATUS PEKERJAAN --- */}
                <Col md={12} className="mb-3">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Status & Jabatan
                  </h6>
                  <hr className="mt-1" />
                </Col>
                <InfoItem
                  label="Status Pekerjaan"
                  value={getLabel(
                    isUsaha
                      ? "statusPekerjaanUsaha"
                      : "statusPekerjaanIndividual",
                    valDetail.stepTiga.statusPekerjaan,
                  )}
                  isPrimary
                />
                <InfoItem
                  label="Nama Pekerjaan"
                  value={valDetail.stepTiga.namaPekerjaan}
                  isPrimary
                />
                <InfoItem
                  label="Kategori Jabatan"
                  value={getLabel(
                    "kategoriJabatan",
                    valDetail.stepTiga.kategoriJabatan,
                  )}
                />
                <InfoItem
                  label="Posisi Jabatan"
                  value={valDetail.stepTiga.posisiJabatan}
                />
                <InfoItem
                  label="Pangkat / Golongan"
                  value={valDetail.stepTiga.pangkatGolongan}
                />
                <InfoItem label="Lama Kerja / Usaha" value={lamaKerjaUsaha} />

                {/* --- SEKSI 2: DETAIL INSTANSI / USAHA --- */}
                <Col md={12} className="mb-3 mt-4">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    {isUsaha
                      ? "Detail Tempat Usaha"
                      : "Detail Instansi / Kantor"}
                  </h6>
                  <hr className="mt-1" />
                </Col>
                {isUsaha ? (
                  <>
                    <InfoItem
                      label="Nama Usaha"
                      value={valDetail.stepTiga.namaUsaha}
                    />
                    <InfoItem
                      label="Bidang Usaha"
                      value={valDetail.stepTiga.bidangUsaha}
                    />
                    <InfoItem
                      label="Alamat Usaha"
                      value={valDetail.stepTiga.alamatUsaha}
                      col={12}
                    />
                  </>
                ) : (
                  <>
                    <InfoItem
                      label="Nama Instansi"
                      value={valDetail.stepTiga.namaInstansi}
                    />
                    <InfoItem
                      label="Telepon Kantor"
                      value={valDetail.stepTiga.telpKantor}
                    />
                    <InfoItem
                      label="Alamat Instansi"
                      value={valDetail.stepTiga.alamatPekerjaan}
                      col={12}
                    />
                    <InfoItem
                      label="Alamat Kantor (Detail)"
                      value={valDetail.stepTiga.alamatKantor}
                      col={12}
                    />
                  </>
                )}

                {/* --- SEKSI 3: INFORMASI KEUANGAN --- */}
                <Col md={12} className="mb-3 mt-4">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Informasi Penghasilan
                  </h6>
                  <hr className="mt-1" />
                </Col>
                {isUsaha ? (
                  <>
                    <InfoItem
                      label="Omset Perbulan"
                      value={formatRupiah(valDetail.stepTiga.omsetPerBulan)}
                      color="#116D6E"
                    />
                    <InfoItem
                      label="Keuntungan Perbulan"
                      value={formatRupiah(
                        valDetail.stepTiga.keuntunganPerBulan,
                      )}
                      color="#116D6E"
                    />
                    <InfoItem
                      label="Pengeluaran Perbulan"
                      value={formatRupiah(
                        valDetail.stepTiga.pengeluaranPerBulan,
                      )}
                      color="#C62D42"
                    />
                  </>
                ) : (
                  <InfoItem
                    label="Penghasilan Bulanan"
                    value={formatRupiah(valDetail.stepTiga.penghasilanBulanan)}
                    color="#116D6E"
                  />
                )}
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 5px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 10px; }
        .fw-800 { font-weight: 800; }
      `}</style>
    </Row>
  );
}

export default Step3;
